import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card5 from "../Images/Profiles/Davis.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function DavisKintu() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Davis Kintu - Senior Laboratory Technician"
        description="Davis Kintu is a Senior Laboratory Technician with a Bachelor's degree in Environmental Management from Makerere University. He holds several professional certifications, including ISO/IEC 17025:2017 and various cookstove testing methodologies."
        keywords="Davis Kintu, Senior Laboratory Technician, CIRCODU, Environmental Management, Makerere University, ISO/IEC 17025:2017, cookstove testing"
        url="/davis-kintu"
        image={Card5}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Davis Kintu</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Mr. Davis Kintu</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card5} alt="Mr. Davis Kintu" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Davis Kintu</h1>
                <p className="profile-card__role">
                  Senior Laboratory Technician
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Davis Kintu graduated from Makerere University with a
                  Bachelor's degree in Environmental Management. His educational
                  foundation is fortified by a series of professional
                  certifications that showcase his proficiency in various
                  domains. These credentials include certificates in the
                  Implementation of ISO/IEC 17025:2017, which pertains to the
                  competence of testing and calibration laboratories, as well as
                  specialized training in methodologies such as the Water
                  Boiling Test Version 4.2.3 (focused on cookstove emissions and
                  efficiency in controlled lab environments), Controlled Cooking
                  Test (C.C.T) Version 2.0, and CIRCODU Emissions Testing
                  methods and protocols. He also holds certificates in stove
                  testing using the Uganda Standard US 761, conducting internal
                  audits based on ISO 9001 and ISO/IEC 17025, and Quality
                  Management System based on ISO/IEC 17025:2017 from the Uganda
                  National Bureau of Standards (UNBS).
                </p>
                <p>
                  Davis has an extensive professional background that
                  encompasses diverse roles. He previously served as a Research
                  Assistant and Laboratory Technician at CIRCODU, where he honed
                  his expertise. Beyond CIRCODU, his experience includes a
                  tenure as a Customer Care Officer at Impact Water and a role
                  as a Research Assistant at Impact Carbon.
                </p>
                <p>
                  Presently, Davis occupies the position of Senior Laboratory
                  Technician at CIRCODU. His role is underscored by a
                  comprehensive skill set that spans various testing
                  methodologies, including WBTs, CCTs, safety assessments,
                  durability tests, emissions evaluations, and kitchen
                  performance tests. Beyond technical proficiency, he
                  demonstrates adeptness in ensuring compliance with health and
                  safety practices within the work environment. Moreover, Davis
                  possesses the acumen to conduct Environmental Impact
                  Assessments and Monitoring for developmental projects. His
                  skill set extends to proficiently utilizing computer tools
                  including Microsoft Word, Microsoft Excel, PowerPoint,
                  Epidata, and SPSS. He is well-versed in employing diverse data
                  collection techniques, encompassing Focus Group Discussions
                  (FGDs), questionnaires, and key informant interviews.
                  Impressively, he can harness technology for data collection
                  through ODK forms and Taro works on smartphones. Davis'
                  analytical prowess spans both quantitative and qualitative
                  data, underpinning his capacity for incisive insights. His
                  communication abilities are underscored by excellence in
                  report writing and presentation, all of which are enhanced by
                  his exceptional interpersonal skills.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/in/kintu-davis-1744286b/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/muwanguzi.davis.12/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256700127623"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:davis.kintu@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DavisKintu;
